import React, { useState } from 'react';

const AccordionPanel = ({ title, children, defaultOpen = false, icon, toggleChecked, onToggleChange }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  const handleHeaderClick = (e) => {
    // Wenn auf die Checkbox geklickt wird, nicht das Panel öffnen/schließen
    if (e.target.type === 'checkbox' || e.target.closest('label')) {
      return;
    }
    setIsOpen(!isOpen);
  };

  const handleToggleClick = (e) => {
    e.stopPropagation();
    if (onToggleChange) {
      onToggleChange(!toggleChecked);
    }
  };

  return (
    <div className="border-b border-dark-border/50 transition-all duration-200 hover:border-dark-border">
      <div 
        className="flex justify-between items-center py-3.5 px-5 cursor-pointer select-none transition-all duration-200 hover:bg-gradient-to-r hover:from-dark-hover/50 hover:to-transparent group relative"
        onClick={handleHeaderClick}
      >
        {/* Subtle left accent line on hover */}
        <div className="absolute left-0 top-0 bottom-0 w-0.5 bg-accent opacity-0 group-hover:opacity-100 transition-opacity duration-200"></div>
        
        <div className="flex items-center gap-3.5 flex-1 min-w-0">
          {icon && (
            <span className="text-base text-dark-text-muted group-hover:text-dark-text transition-all duration-200 flex items-center flex-shrink-0 group-hover:scale-110">
              {icon}
            </span>
          )}
          <span className="text-sm font-semibold text-dark-text tracking-tight flex-1 truncate group-hover:text-dark-text transition-colors duration-200">{title}</span>
          {toggleChecked !== undefined && (
            <label 
              className="flex items-center gap-2 cursor-pointer flex-shrink-0"
              onClick={handleToggleClick}
            >
              <input
                type="checkbox"
                checked={toggleChecked}
                onChange={handleToggleClick}
                className="w-4 h-4 cursor-pointer accent-accent rounded transition-all duration-200 hover:scale-110"
                onClick={(e) => e.stopPropagation()}
              />
            </label>
          )}
        </div>
        <span className={`text-xs text-dark-text-muted transition-all duration-300 ml-2 flex-shrink-0 group-hover:text-dark-text ${isOpen ? 'rotate-0' : '-rotate-90'}`}>
          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4 6L1 3L7 3L4 6Z" fill="currentColor"/>
          </svg>
        </span>
      </div>
      {isOpen && (
        <div className="px-5 pb-5 pt-3 bg-transparent animate-[slideDown_0.25s_ease-out]">
          {children}
        </div>
      )}
    </div>
  );
};

export default AccordionPanel;
